import { Promotion } from '../crm-offer-data/crm-offer.model';

export function preloadPromotionImage(promotion: Promotion, doc: Document): void {
    if (promotion?.banner?.heroImageUrl && !doc.head.querySelector(`link[href="${promotion.banner?.heroImageUrl}"]`)) {
        const link = doc.createElement('link');
        const imageUrl = promotion.banner.heroImageUrl;
        link.rel = 'preload';
        link.href = imageUrl;
        link.as = 'image';
        doc.head.appendChild(link);
    }
}
